import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { Editor } from 'ngx-editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { JoditAngularComponent } from 'jodit-angular';



@Component({
  selector: 'app-elcm-create-email-templet',
  templateUrl: './elcm-create-email-templet.component.html',
  styleUrls: ['./elcm-create-email-templet.component.scss'],

})
export class ElcmCreateEmailTempletComponent implements OnInit {

  editor!: Editor;
  htmlContent = new FormControl('');

  @ViewChild('applicationFormLink') applicationFormLink: ElementRef | undefined;
  invitationEmailSubject: any='';
  isPublished: boolean = false;
  buttonColorName: any
  PopupName: any
  green = '#05ca05';
  employeeApplicationEmailBody: any = '';
  offerlaterEmailBody: any = '';
  public Editor = ClassicEditor;

  text: string = '<p>Hello, this is default text in editor!</p>'; // ✅ Default text



  editorContent: string = '<p>Welcome to Jodit Editor!</p>';
  submissionEmailBody: any = '';
  appoinmentlaterEmailBody: any = '';
  textControl = new FormControl('<p>Hello, this is default text in editor!</p>'); // ✅ Use FormControl
  isEditing = false;

  editorConfig: any  

//  editorConfig:any={
  //           height: 430,
  //           toolbarSticky: false,
  //           toolbarAdaptive: false,
  //           askBeforePasteHTML: true,
  //           askBeforePasteFromWord: true,
  //           // defaultActionOnPaste: 'insert_clear_html',
  //           defaultActionOnPaste: 'insert_as_html',
        
  //           language: 'en',
  //           i18n: {
  //             en: {
  //               // ✅ Title
  //               'Paste as HTML': 'Paste',
        
  //               // ✅ Message body
  //               'Your code is similar to HTML. Keep as HTML?':
  //                 ' Do you want to keep this content as it is ?',
  //             }
  //           },
  //           uploader: {
  //             insertImageAsBase64URI: true
  //           },
  //           buttons: [
  //             'bold', 'italic', 'underline', '|',
  //             'ul', 'ol', '|',
  //             'left', 'center', 'right', 'justify', '|',
  //             'preview', '|',
  //             'undo', 'redo', '|',
  //             'fontsize',
  //             'link'
  //           ]
  //         };

  @ViewChild('joditEditor') joditEditor!: JoditAngularComponent;



  createSurveyForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserRole: any;
  selectedYear: any;
  popupName: any;
  isDisabledIncrementLetter: any;
  emplyeeName: any = "#EmployeeName#"
  companyYear: any;
  letterContentFromBirthday: any;
  letterContentFromAnniversaries: any
  modulename:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private toastController: ToastController,
    public sharedService: SharedService, public dialogRef: MatDialogRef<ElcmCreateEmailTempletComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    private renderer: Renderer2, private el: ElementRef,private cd: ChangeDetectorRef,
  ) {

    this.popupName = data.popupName;
    this.companyYear = data.companyYear;
    this.isDisabledIncrementLetter = data.isDisabledIncrementLetter;
    this.modulename=data?.elcmModule;
    console.log(this.popupName);

  }
  editorForm = new FormGroup({
    editor: new FormControl('<p>Default content</p>')
  });
  // ngOnInit() {
     


  //   this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  //   this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
  //   this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
  //   this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
  //   if (this.loggedInUserRole) {
  //     this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
  //   }
  //   this.buttonColorName = sessionStorage.getItem('buttonColorName');
  //   if(this.modulename!=='elcm'){

  //     this.getlandimgpageMail();
  //   }
  //   this.getMailBodyData();
  //   this.getletterContent();

  //   setTimeout(() => {
  //     this.mailTemplateSave();
  //   }, 300)
  //     this.editorConfig={
  //           height: 430,
  //           toolbarSticky: false,
  //           toolbarAdaptive: false,
  //           askBeforePasteHTML: true,
  //           askBeforePasteFromWord: true,
  //           // defaultActionOnPaste: 'insert_clear_html',
  //           defaultActionOnPaste: 'insert_as_html',
        
  //           language: 'en',
  //           i18n: {
  //             en: {
  //               // ✅ Title
  //               'Paste as HTML': 'Paste',
        
  //               // ✅ Message body
  //               'Your code is similar to HTML. Keep as HTML?':
  //                 ' Do you want to keep this content as it is ?',
  //             }
  //           },
  //           uploader: {
  //             insertImageAsBase64URI: true
  //           },
  //           buttons: [
  //             'bold', 'italic', 'underline', '|',
  //             'ul', 'ol', '|',
  //             'left', 'center', 'right', 'justify', '|',
  //             'preview', '|',
  //             'undo', 'redo', '|',
  //             'fontsize',
  //             'link'
  //           ]
  //         };
  //   this.editor = new Editor();
  // }
  ngOnInit() {

  // -------------------------
  // LOGIN / SESSION VALUES
  // -------------------------
  this.loggedInUserCompanyID = Number(
    this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID'))
  );

  this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
  this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

  this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
  if (this.loggedInUserRole) {
    this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
  }

  this.buttonColorName = sessionStorage.getItem('buttonColorName');


  // -------------------------
  // LOAD MAIL CONTENT
  // -------------------------
  if (this.modulename !== 'elcm') {
    this.getlandimgpageMail();
  }

  this.getMailBodyData();
  this.getletterContent();

  setTimeout(() => {
    this.mailTemplateSave();
  }, 300);


  // -------------------------
  // JODIT EDITOR CONFIG
  // -------------------------
  this.editorConfig = {
    height: 430,
    toolbarSticky: false,
    toolbarAdaptive: false,

    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_html',

    language: 'en',
    i18n: {
      en: {
        'Paste as HTML': 'Paste',
        'Your code is similar to HTML. Keep as HTML?': 'Do you want to keep this content as it is ?',
      }
    },

    uploader: {
      insertImageAsBase64URI: true
    },

    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'left', 'center', 'right', 'justify', '|',
      'preview', '|',
      'undo', 'redo', '|',
      'fontsize',
      'link'
    ]
  };

  this.editor = new Editor();
}

  employeeApplicationEmailBodyFromBAckend: any;
  allemailtempalteData: any = [];

  getMailBodyData() {
    this.httpService.callGetService(`${this.config.emailtempletGetDataByCompany}?companyId=${this.loggedInUserCompanyID}&year=${this.companyYear}`).subscribe((record: any) => {
      if (record?.data.length > 0) {
        this.allemailtempalteData = record?.data;
      }
    })
  }

  toggleEditMode() {
    this.isEditing = !this.isEditing;
    // this.editorConfig = { ...this.editorConfig, readonly: !this.isEditing }; // Toggle readonly mode
  }
  subjectClick: any = '';
  subjectclick(event: any) {
    this.subjectClick = event

  }
  addToEditor(textToAdd: string) {
    const editor = document.getElementById('htmlDiv');
    if (!editor) return;
    console.log(this.subjectClick);

    if (this.subjectClick === 'subject' || this.subjectClick === '') {
      return;
    } {

      document.execCommand(
        'insertHTML',
        false,

        `<span>
    <b>${textToAdd}</b>
</span>`
      );
    }


  }






  @HostListener('keydown', ['$event'])
  preventBackspace(event: KeyboardEvent) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const currentNode = range.startContainer.parentElement;
    if (!currentNode) return;

    // Prevent deletion when cursor is directly inside the protected text
    if (currentNode.classList.contains('protected-text') &&
      (event.key === 'Backspace' || event.key === 'Delete')) {
      event.preventDefault();
      return;
    }

    // Check if user tries to delete a protected text span
    const previousNode = range.startContainer.previousSibling as HTMLElement;
    const nextNode = range.startContainer.nextSibling as HTMLElement;

    if ((previousNode && previousNode.classList?.contains('protected-text')) ||
      (nextNode && nextNode.classList?.contains('protected-text'))) {
      // event.preventDefault();
    }
  }








  employeeApplicationEmailBodyFromBAckendfrontEndEmail: any
  mailTemplateSave() {
    if (this.popupName == 'Create Email Body for Employment application') {

      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'ELCM_EMPLOYEE_APPLICATION');
      console.log(emailbody);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      console.log(emailbody);


      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;

      }

      else {
        this.employeeApplicationEmailBodyFromBAckendfrontEndEmail = 'ELCM_EMPLOYEE_APPLICATION';
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
        Dear <b>#EmployeeName#</b>, 
        <br /><br />
        Further to our discussions with you, we are delighted to start the process of offer and onboarding. Hence, we request you to click on the 
        <a id="applicationFormLink" target="_blank"><b>#EmploymentApplicationFormLink#</b></a>
        link, fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.
        <br /><br />
      
      
        Best regards, 
        <br />
        
        <br />Human Resources Team
      `;
      }
    } else if (this.popupName == 'Create Email Body for Intimation email') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Intimation email from candidate');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
      I Candidate name have submitted the employment application form with supportings. All information provided by me is <br>
      accurate.
      `;

      }
    } else if (this.popupName == 'Create Email Body for offer letter email') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Offer letter');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        // this.invitationEmailSubject = emailbody[0]?.subject;
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
      We are pleased to extend an offer to you dated You are requested to confirm acceptance to the same..
      `;
      }
    }
    else if (this.popupName == 'Create Email Body for Appoinment letter issuance') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Appointment Latter');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
       \nDear <b>#EmployeeName#</b>, 
       We are delighted that you have joined us and we are pleased to issue an appointment
        letter to you as enclosed as an attachment. Please sign a copy of it and return it by email/ hard copy for our records"
      `;
      }
    }
    else if (this.popupName == 'Confirmation letter mail with no change') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'CONFIRMATION_LETTER_WITHOUT_CHANGES_ELCM');
      console.log(this.allemailtempalteData);


      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
     Dear #EmployeeName#,
     <br><br>Further to our discussions with you, we are delighted to start the process of offer
      and onboarding. Hence, we request you to click on the employment application form link, 
     fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>"

      `;
      }
    }
    else if (this.popupName == 'confirmation with change') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'CONFIRMATION_LETTER_WITH_CHANGES_ELCM');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        // this.invitationEmailSubject = emailbody[0]?.subject;
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
   Dear #EmployeeName#,<br><br>Further to our discussions with you, 
   we are delighted to start the process of offer and onboarding. Hence, 
   we request you to click on the employment application form link, 
   fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>
      `;
      }
    }
    else if (this.popupName == 'Extention of probation letter mail') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'EXTENTION_PROBATION_LETTER_ECLM');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
   Dear #EmployeeName#,<br><br>Further to our discussions with you, we are delighted to 
   start the process of offer and onboarding. Hence, we request you to click on the employment application 
   form link, fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>
      `;
      }
    }

    else if (this.popupName == 'Create Email Body for Termination Mail') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'TERMINATION_MAIL');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
   Dear #EmployeeName#,
      `;
      }
    }
    else if (this.popupName == 'Create Email Body Reliving/Experience mail') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'RELIVING_EXPERIENCE');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EmployeeName#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to Phiedge HRMS ";
        this.employeeApplicationEmailBody = `
   Dear #EmployeeName#,
      `;
      }
    }

  }
  decodeHtml(html: string): string {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.replace(/&#10;/g, '\n'); // Convert line breaks properly
  }









  // ----------------------------------------------------------------------------------------------------------------------------------------------------------------

  decodeHtmlAndFormat(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    let decoded = txt.value;

    // Remove unwanted metadata and tags
    decoded = decoded
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<meta[^>]*>/gi, '')
      .replace(/<\?xml[^>]*\?>/gi, '');

    // Clean common formatting issues
    decoded = decoded
      .replace(/\\n/g, '\n')
      .replace(/(&nbsp;|&#160;)+/g, ' ')
      .replace(/&(?![a-zA-Z0-9#]+;)/g, '&amp;')
      .replace(/<br\s*>/gi, '\n')
      .replace(/<br([^>]*)>/gi, '<br$1 />')
      .replace(/<img([^>]*)(?<!\/)>/gi, '<img$1 />');

    // Sanitize MS Word tags
    decoded = this.sanitizeWordHtml(decoded);



    // // Standardize letter headings
    // const headings: [RegExp, string][] = [
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*OFFER(?:\s|&nbsp;|<[^>]*>)*LETTER(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-size: 18pt; font-weight: bold;">OFFER LETTER</h2>'],
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*(?:j\s*o\s*b)(?:\s|&nbsp;|<[^>]*>)*offer(?:\s|&nbsp;|<[^>]*>)*letter(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-size: 18pt; font-weight: bold;">JOB OFFER LETTER</h2>'],
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*APPOINTMENT(?:\s|&nbsp;|<[^>]*>)*LETTER(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-weight: bold;">APPOINTMENT LETTER</h2>'],
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*CONFIRMATION(?:\s|&nbsp;|<[^>]*>)*LETTER(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-size: 18pt; font-weight: bold;">CONFIRMATION LETTER</h2>'],
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*(?:EXTENSION(?:\s|&nbsp;|<[^>]*>)*LETTER|LETTER(?:\s|&nbsp;|<[^>]*>)*EXTENSION)(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-size: 18pt; font-weight: bold;">EXTENSION LETTER</h2>'],
    //   [/<(p|div|span|h[1-6])[^>]*>(?:\s|&nbsp;|<[^>]*>)*TERMS(?:\s|&nbsp;|<[^>]*>)*AND(?:\s|&nbsp;|<[^>]*>)*CONDITIONS(?:\s|&nbsp;|<[^>]*>)*OF(?:\s|&nbsp;|<[^>]*>)*EMPLOYMENT(?:\s|&nbsp;|<[^>]*>)*<\/\1>/gi, '<h2 style="text-align: center; font-size: 12pt; font-weight: bold;">TERMS AND CONDITIONS OF EMPLOYMENT</h2>']
    // ];
    // headings.forEach(([pattern, replacement]) => decoded = decoded.replace(pattern, replacement));

    // Convert bullet symbols to proper list
    decoded = decoded.replace(/<p[^>]*>\s*(•|▪|‣|\u2022)\s*(.*?)<\/p>/gi, '<ul><li>$2</li></ul>');

    // Auto-close unclosed tags
    const tagsToClose = ['p', 'div', 'li', 'ul', 'ol', 'table', 'tr', 'td', 'thead', 'tfoot', 'tbody', 'span', 'b', 'i', 'u', 'strong', 'em'];
    tagsToClose.forEach(tag => {
      const openCount = (decoded.match(new RegExp(`<${tag}(\\s[^>]*)?>`, 'gi')) || []).length;
      const closeCount = (decoded.match(new RegExp(`</${tag}>`, 'gi')) || []).length;
      const diff = openCount - closeCount;
      if (diff > 0) {
        decoded += `</${tag}>`.repeat(diff);
      }
    });

    // Wrap content in XHTML structure
    const wrapper = document.createElement('div');
    wrapper.innerHTML = decoded;

    const doc = document.implementation.createDocument('', '', null);
    const htmlEl = doc.createElement('html');
    htmlEl.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');

    const headEl = doc.createElement('head');
    const styleEl = doc.createElement('style');
    styleEl.textContent = `
    @page {
      size: A4;
      margin-top: 120px;
      margin-bottom: 130px;
      margin-left: 50px;
      margin-right: 40px;
    }
    body {
      margin: 0;
      padding: 0;
font-family: Arial, sans-serif;

      font-size: 12pt;
      line-height: 1.4;
      padding-bottom: 0;
    }
    div, p {
      display: block;
    }
    ul, ol {
      margin-left: 20px;
      padding-left: 20px;
    }
    li {
      margin-bottom: 4px;
    }
  `;
    headEl.appendChild(styleEl);

    const bodyEl = doc.createElement('body');
    Array.from(wrapper.childNodes).forEach((node) => {
      bodyEl.appendChild(doc.importNode(node, true));
    });

    htmlEl.appendChild(headEl);
    htmlEl.appendChild(bodyEl);
    doc.appendChild(htmlEl);

    const finalXhtml = new XMLSerializer().serializeToString(doc);
    return `<!DOCTYPE html>\n${finalXhtml}`;
  }







  sanitizeWordHtml(html: string): string {
    // Step 1: Initial cleanup using regex
    const cleaned = html
      .replace(/<\?xml[^>]*\?>/gi, '')
      .replace(/xmlns(:\w+)?="[^"]*"/gi, '')
      .replace(/<(\/?)(o|w|v|m|st1):[^>]*>/gi, '')
      .replace(/<!--\[if [\s\S]*?<!\[endif\]-->/gi, '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<meta[^>]*>/gi, '')
      .replace(/\s+[a-z]+:[a-z\-]+="[^"]*"/gi, '')

      // Self-closing void elements (to be XHTML-compliant)
      .replace(/<br([^>]*)>/gi, '<br$1 />')
      .replace(/<hr([^>]*)>/gi, '<hr$1 />')
      .replace(/<img([^>]*?)(?<!\/)>/gi, '<img$1 />')
      .replace(/<input([^>]*)>(?!<\/input>)/gi, '<input$1 />')

      // Strip invalid attributes (namespaced)
      .replace(/<([a-z1-6]+)([^>]*)>/gi, (match, tag, attrs) => {
        const cleanedAttrs: string[] = [];
        const attrRegex = /([a-zA-Z0-9\-:_]+)\s*=\s*(['"])(.*?)\2/g;
        let m;
        while ((m = attrRegex.exec(attrs)) !== null) {
          if (!m[1].includes(':')) {
            cleanedAttrs.push(`${m[1]}="${m[3]}"`);
          }
        }
        return `<${tag}${cleanedAttrs.length ? ' ' + cleanedAttrs.join(' ') : ''}>`;
      });

    // Step 2: Create a DOM wrapper and let browser auto-fix structure
    const wrapper = document.createElement('div');
    wrapper.innerHTML = cleaned;

    // Step 3: Manually walk DOM and ensure strict XHTML-compliant closing
    const forceTagClosing = (node: Node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as HTMLElement;
        const tagName = el.tagName.toLowerCase();

        // For tags that must have a closing tag even if empty (e.g. <a></a>)
        const forceClosingTags = ['a', 'b', 'i', 'u', 'span', 'strong', 'em', 'p', 'div', 'td', 'th', 'tr', 'thead', 'tbody', 'tfoot'];

        if (forceClosingTags.includes(tagName) && el.innerHTML.trim() === '') {
          el.innerHTML = '&#8203;'; // zero-width space to enforce closing tag
        }
      }

      for (let i = 0; i < node.childNodes.length; i++) {
        forceTagClosing(node.childNodes[i]);
      }
    };

    forceTagClosing(wrapper);

    // Step 4: Serialize DOM back to XHTML
    let xhtml = new XMLSerializer().serializeToString(wrapper);

    // Step 5: Remove outer <div> wrapper added for parsing
    xhtml = xhtml.replace(/^<div[^>]*>/i, '').replace(/<\/div>$/i, '');

    return xhtml;
  }

  getlandimgpageMail() {
    this.httpService.callGetService(`${this.config.addOrUpdateMail}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      console.log(response);
      this.letterContentFromBirthday = response?.data?.fromEmailForBirthday;
      this.letterContentFromAnniversaries = response?.data?.fromEmailForAnniversary
    })
  }


  letterContentsubject: any;
  letterContentBody: string = ''; // Initialize with an empty string or some default text
  letterContentBodyReadonly: string = '';
  employeeApplicationcontentBodyFromBackend: any
  employeeApplicationcontentBodyFromFrontEnd: any
  termContent: any;
  termSubject: any;
  termName: any;

//   getletterContent() {
//     this.httpService.callGetService(`${this.config.getAllLatterFORELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.companyYear}`).subscribe((record: any) => {
//       console.log(record);

//       if (this.popupName == 'Create offer letter content') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'Offer Letter');
//         // let contentbody: any = []
//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;


//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           // this.letterContentBody = this.decodeHtmlAndFormat(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {
//           this.employeeApplicationcontentBodyFromFrontEnd = "Offer Letter";
//           this.letterContentsubject = "#EmployeeName# Offer Letter .";
//           this.letterContentBody = `<!DOCTYPE html>
// <html xmlns="http://www.w3.org/1999/xhtml">
//   <head>
//     <style>
//       @page {
//         size: A4;
//         margin-top: 120px;
//         margin-bottom: 100px;
//         margin-left: 50px;
//         margin-right: 40px;
//       }
//       body {
//         padding: 0;
//         font-family: Calibri, sans-serif;
//         font-size: 12pt;
//         line-height: 1.5;
//       }
//       p {
//         margin-bottom: 12px;
//       }
//     </style>
//   </head>
//   <body>
//     <p><strong>Ref:</strong> HRD/LOF/ACIPL/2024-25-133</p>
//     <p><strong>Date:</strong> #TodayDate#</p>

//     <h2 style="text-align: center; font-size: 18pt;">OFFER LETTER</h2>

//     <p>To,<br />#EmployeeName#<br />#Address#</p>
//     <p>Dear #Salutation# #EmployeeName#,</p>

//     <p>This is with reference to your application &amp; subsequent interviews you had with us. We are pleased to offer you the position of <strong>“#Designation# – #Department# #WorkLocationState#”</strong> with Accurub Corptech India Pvt. Ltd. at Chakan, Pune, as per the terms and conditions discussed with you.</p>

//     <p>The detail of your remuneration is contained in Annexure-I attached herewith. With acceptance of this offer letter, you agree to abide by company policies and confidentiality agreement. Please acknowledge your acceptance of this offer and its conditions.</p>

//     <p><strong>You are requested to join the duties on or before #DateOfJoining#.</strong> If this letter is not accepted within two days of issue, it shall stand  If you fail to join on the said date, this offer letter shall be treated as cancelled unless extension in writing is granted.</p>

//     <p><strong>The contents of this letter are STRICTLY CONFIDENTIAL and should not be divulged to anyone.</strong></p>

//     <p>Please bring the following documents at the time of joining:</p>
//     <ol>
//       <li>10th, 12th, Graduation, Post-graduation certificates and all mark sheets (clear &amp; uncut copies).</li>
//       <li>Offer Letter, Release Letter, 3-months' Pay Slips of last organization (if applicable).</li>
//       <li>Self-attested copy of ID proof: Driving License / Passport / PAN / Aadhaar.</li>
//       <li>Address proof: Ration card / Electricity bill / Rent agreement / Landline bill / Passport / Voter ID.</li>
//       <li>PAN Card &amp; Aadhaar Card (self-attested), Bank Passbook (xerox), Photo (JPG), and Updated CV.</li>
//     </ol>

//     <p>This offer letter is conditional to the satisfactory completion of background checks and document verification.</p>
//     <p><strong>Failure to clear any of the above checks will lead to immediate withdrawal of this offer letter.</strong></p>

//     <p>Please sign and return a duplicate copy of this letter as a token of your acceptance.</p>

//     <p><strong>Thanking you,</strong></p>
//     <p><strong>For,</strong><br /><strong>ACCURUB CORPTECH INDIA PVT LTD</strong></p>

//     <p><strong>MAYUR GHEL</strong><br />MANAGER - HR &amp; ADMIN</p>
    
//      <p><strong>Signature of Employee</strong></p>
       
//   </body>
// </html>
// `;
//         }

//       } else if (this.popupName == 'Create Appoinment letter content') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'Appointment Letter');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           // this.letterContentBody = decodedContent.replace(/\n/g, '<br>');
//           this.letterContentBody = contentbodytemlate;
//         } else {

//           this.employeeApplicationcontentBodyFromFrontEnd = "Appointment Letter"
//           this.letterContentsubject = "#EmployeeName# Appointment Letter";

//           this.letterContentBody = `<!DOCTYPE html>
// <html xmlns="http://www.w3.org/1999/xhtml">
//   <head>
//     <style>
//       @page {
//         size: A4;
//         margin-top: 120px;
//         margin-bottom: 100px;
//         margin-left: 50px;
//         margin-right: 40px;
//       }
//       body {
//         padding: 0;
//         font-family: Calibri, sans-serif;
//         font-size: 12pt;
//         line-height: 1.5;
//       }
//       p {
//         margin-bottom: 12px;
//       }
//     </style>
//   </head>
//   <body>
//     <p><strong>Ref:</strong> SIL/HR/04</p>
//     <p><strong>Date:</strong> #TodayDate#</p>

//     <h2 style="text-align: center; font-size: 18pt;">LETTER OF APPOINTMENT</h2>

//     <p>To,<br />Ms. #EmployeeName#<br />#Address#</p>

//     <p><strong>Subject:</strong> Letter of Appointment</p>

//     <p>Dear #EmployeeName#,</p>

//     <p>With reference to your application &amp; subsequent interview with us, we are pleased to offer you employment in our organization on the following terms and conditions:</p>

//     <p><strong>1. Effective Date of Appointment:</strong> #TodayDate#<br/>
//     <strong>2. Designation:</strong> #Designation#<br/>
//     <strong>3. Initial Place of Work:</strong> #WorkLocationState#<br/>
//     <strong>4. Band:</strong> #Band#</p>

//     <p><strong>01. Personal Particulars:</strong><br/>
//     You will keep us informed of any change in your residential address, your family status, or any other relevant particulars...</p>

//     <p><strong>02. Remuneration:</strong><br/>
//     Your remuneration will be set out in Annexure A hereto...</p>

//     <p><strong>03. Training &amp; Development:</strong><br/>
//     You may be required to undergo training...</p>

//     <p><strong>04. Nature of Work:</strong><br/>
//     Your nature of work mainly includes all aspects...</p>

//     <p><strong>05. Probation, Confirmation &amp; Termination of Employment:</strong><br/>
//     You will be on probation for a period of six months...</p>

//     <p><strong>06. Provident Fund and Gratuity:</strong><br/>
//     You will be entitled to receive PF and Gratuity...</p>

//     <p><strong>07. Leaves:</strong><br/>
//     You will be entitled to leaves as per applicable legal provisions...</p>

//     <p><strong>08. Retirement Age:</strong><br/>
//     The normal age of retirement is 60 years...</p>

//     <p><strong>09. Resignation:</strong><br/>
//     On acceptance of your resignation letter...</p>

//     <p><strong>10. Transfer:</strong><br/>
//     You may be required to work for any associate...</p>

//     <p><strong>11. Intellectual Property Rights:</strong><br/>
//     If, during the period of your employment with us...</p>

//     <p><strong>12. Code of Conduct:</strong><br/>
//     You will continuously endeavor to achieve excellence...</p>

//     <p><strong>13. Working Hrs. &amp; Administrative Rules:</strong><br/>
//     You need to work as per the shifts (timing)...</p>

//     <p><strong>14. Conflict of Interest:</strong><br/>
//     You will be required to disclose to the Company...</p>

//     <p><strong>15. Standing Orders:</strong><br/>
//     You will abide by the Standing Orders...</p>

//     <p><strong>16. Jurisdiction:</strong><br/>
//     In the event of any dispute arising under...</p>

//     <p><strong>17.</strong> We trust that you have not provided us with any false declaration...</p>

//     <p><strong>18.</strong> You will not enter into any commitments or dealings...</p>

//     <p><strong>19.</strong> You shall perform your duties with diligence, devotion</p>

//     <p><strong>Sincerely,</strong></p>
//     <p><strong>#Designation#</strong><br/>
//     <strong>#CompanyName#</strong></p>

//     <p><strong>Signature of Employee</strong></p>
//     <p>#SignaturePath#</p>
//   </body>
// </html>
// `
//         }
//       }
//       else if (this.popupName == 'Add term And Condition') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'Terms and Conditions' || elm.name == 'Terms and Conditions');


//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.termName = contentbody[0]?.name;
//           this.termSubject = contentbody[0]?.title;
//           this.termContent = contentbodytemlate            // remove leading/trailing spaces

//         } else {
//           this.termName = "Terms and Conditions"
//           this.termSubject = "Terms and Conditions";
//           this.termContent = ``
//         }
//       }


//       else if (this.popupName == 'Confirmation letter content with no change') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'CONFIRMATION LETTER WITHOUT CHANGES');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {

//           this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITHOUT CHANGES"
//           this.letterContentsubject = "#EmployeeName# Confirmation Letter";
//           this.letterContentBody = `
//          Ref.: SIL/HR/09\n
//         Date: \n
// To                                                                                            
// Mr. #EmployeeName#\n

// #Address#\n

// Subject: Letter of Confirmation\n

// Dear #EmployeeName#, \n
// Further to your appointment letter dated on #TodayDate#. We are pleased to inform you that your services with Sellowrap Industries Limited have been confirmed with effect from #TodayDate# as ‘#Designation# - #Department#’ in Band ‘#Band#’.\n

// You will be governed by the service rules and regulations of the company that are already in force and as may be issued from time to time.\n

// Other terms and conditions as embodied in the appointment letter and policy manual will remain unchanged.\n

// #CompanyName# congratulates you as on your confirmation and wishes you well in your position.\n

// In token of your acceptance of the above terms and conditions, please sign and return the duplicate copy of this letter.\n

// Yours truly,\n

// For’ Sellowrap Industries Limited\n

// Authorised Signatory\n
//    TERMS ACCEPTED\n

//         `.replace(/\n/g, '<br>');
//         }
//       }
//       else if (this.popupName == 'Confirmation letter content with change') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'CONFIRMATION LETTER WITH CHANGES');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {
//           this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITH CHANGES"
//           this.letterContentsubject = "#EmployeeName# Confirmation Letter";
//           this.letterContentBody = `
//          Ref.: SIL/HR/09\n
//         Date: \n
// To Mr. #EmployeeName#\n
// #Address#\n

// Subject: Letter of Confirmation\n

// Dear #EmployeeName#, \n

// Further to your appointment letter dated on #TodayDate#. We are pleased to inform you that your services with Sellowrap Industries Limited have been confirmed with effect from #TodayDate# as ‘#Designation# - #Department#’ in Band ‘#Band#’.\n

// You will be governed by the service rules and regulations of the company that are already in force and as may be issued from time to time.\n

// Other terms and conditions as embodied in the appointment letter and policy manual will remain unchanged.\n

// #CompanyName# congratulates you as on your confirmation and wishes you well in your position.\n

// In token of your acceptance of the above terms and conditions, please sign and return the duplicate copy of this letter.\n

// Yours truly,\n

// For’ Sellowrap Industries Limited\n

// Authorised Signatory\n
//    TERMS ACCEPTED\n

//         `.replace(/\n/g, '<br>');
//         }
//       }
//       else if (this.popupName == 'Extention of probation content') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'EXTENSION PROBATION');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {

//           this.employeeApplicationcontentBodyFromFrontEnd = "EXTENSION PROBATION"
//           this.letterContentsubject = "#EmployeeName# Confirmation Letter";
//           this.letterContentBody = `
//       Date: #TodayDate# \n
      
//       To, #EmployeeName# \n#Address# \n

//       Subject: Extension of Probation Period \n

//       Dear #EmployeeName#, \n
      
//       We would like to inform you that your probation period at #CompanyName#, which was initially set to end on #dateOfConfirmation#, has been extended. The new probation end date will be . \nThis extension has been decided to provide you with additional time to meet the performance expectations required for confirmation in your role as #Designation#. During this period, you are expected to continue demonstrating progress in your responsibilities and alignment with company standards. \n
      
//       If you have any questions regarding this extension, please feel free to reach out to the HR department\n
      
//       Best Regards,\n
      
//       #EmployeeName# \n
      
//       #Designation# \n
      
//       #CompanyName#

//       `.replace(/\n/g, '<br>');
//         }
//       }
//       // ---------------------------------------------------------------- start for increment ------------------------------------------------------------------
//       else if (this.popupName == 'Add term And Condition for increment') {

//         let contentbody = record.data.filter((elm: any) => elm.name == 'Terms and Conditions for Increment' || elm.name == 'Terms and Conditions for Increment');


//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.termName = contentbody[0]?.name;
//           this.termSubject = contentbody[0]?.title;
//           this.termContent = contentbodytemlate            // remove leading/trailing spaces

//         } else {
//           this.termName = "Terms and Conditions for Increment"
//           this.termSubject = "Terms and Conditions";
//           this.termContent = ``
//         }
//       }
//       else if (this.popupName == 'Create Email Body for landing page') {



//         let contentbody = record.data.filter((elm: any) => elm.name == 'Birthday Wishes');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {

//           this.employeeApplicationcontentBodyFromFrontEnd = 'Birthday Wishes'
//           this.letterContentsubject = 'Birthday Wishes';
//           this.letterContentBody = `
// Dear #Salutation# #EmployeeName#,
// Wishing you a day filled with joy, laughter, and everything that makes you happy! 🎂
// Your contribution to our team is truly appreciated, and we hope this special day brings you all the happiness you deserve.
// Warmest wishes,
// HR Team
// `
//             .split('\n')
//             .map(line => line.trim()) // optional: remove extra spaces at start/end
//             .filter(line => line) // remove empty lines if you want
//             .map(line => `<span style="display:block; line-height:1.8;">${line}</span>`) // add line height
//             .join('');

//         }

//       }
//       else if (this.popupName == 'Create Email Body for anniversary wishes') {



//         let contentbody = record.data.filter((elm: any) => elm.name == 'Work Anniversary Wishes');

//         console.log(contentbody);

//         this.employeeApplicationcontentBodyFromBackend = contentbody;
//         let contentbodytemlate = contentbody[0]?.content;
//         if (contentbody.length > 0) {
//           this.letterContentsubject = contentbody[0]?.title;
//           // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
//           // this.letterContentBody = contentbodytemlate;
//           let decodedContent = this.decodeHtml(contentbodytemlate);
//           this.letterContentBody = contentbodytemlate;

//         } else {

//           this.employeeApplicationcontentBodyFromFrontEnd = 'Work Anniversary Wishes'
//           this.letterContentsubject = 'Work Anniversary Wishes';
//           this.letterContentBody = `
// Dear #Salutation# #EmployeeName#,
 
// Congratulations on completing another amazing year with us!
 
// Your dedication, hard work, and commitment are truly valued. We are lucky to have you on our team and look forward to many more milestones together.
 
// Best wishes on your work anniversary!
 
// HR Team
 
// `
//             .split('\n')
//             .map(line => line.trim()) // optional: remove extra spaces at start/end
//             .filter(line => line) // remove empty lines if you want
//             .map(line => `<span style="display:block; line-height:1.8;">${line}</span>`) // add line height
//             .join('');


//         }

//       }
//     })
//     // ---------------------------------------------------------------- End for increment ------------------------------------------------------------------

//   }
getletterContent() {
  this.httpService
    .callGetService(`${this.config.getAllLatterFORELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.companyYear}`)
    .subscribe((record: any) => {
      console.log(record);

      if (this.popupName == 'Create offer letter content') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Offer Letter');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
          console.log("hello");
          
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Offer Letter";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }

      } else if (this.popupName == 'Create Appoinment letter content') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Appointment Letter');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Appointment Letter";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
           setTimeout(() => {
      if (this.cd) this.cd.detectChanges();
    });
        }

      } else if (this.popupName == 'Add term And Condition') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Terms and Conditions');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.termName = contentbody[0]?.name;
          this.termSubject = contentbody[0]?.title;
          this.termContent = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Terms and Conditions";
          this.termName = 'Terms and Conditions';
          this.termSubject = ' ';
          this.termContent = ' ';
        }

      } else if (this.popupName == 'Confirmation letter content with no change') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'CONFIRMATION LETTER WITHOUT CHANGES');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITHOUT CHANGES";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }

      } else if (this.popupName == 'Confirmation letter content with change') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'CONFIRMATION LETTER WITH CHANGES');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITH CHANGES";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }

      } else if (this.popupName == 'Extention of probation content') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'EXTENSION PROBATION');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "EXTENSION PROBATION";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }

      } else if (this.popupName == 'Add term And Condition for increment') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Terms and Conditions for Increment');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.termName = contentbody[0]?.name;
          this.termSubject = contentbody[0]?.title;
          this.termContent = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Terms and Conditions for Increment";
          this.termName = 'Terms and Conditions for Increment';
          this.termSubject = ' ';
          this.termContent = ' ';
        }

      }
       else if (this.popupName == 'Reliving/Experience letter content') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Reliving/Experience letter');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Reliving/Experience letter";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }
      }else if (this.popupName == 'Termination letter content') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Termination letter');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Termination letter";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }
      }
       else if (this.popupName == 'Create Email Body for landing page') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Birthday Wishes');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Birthday Wishes";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }

      } else if (this.popupName == 'Create Email Body for anniversary wishes') {
        const contentbody = record.data.filter((elm: any) => elm.name === 'Work Anniversary Wishes');
        this.employeeApplicationcontentBodyFromBackend = contentbody;

        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          this.letterContentBody = contentbody[0]?.content;
        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "Work Anniversary Wishes";
          this.letterContentsubject = ' ';
          this.letterContentBody = ' ';
        }
      }
    });
}

  ngAfterViewInit() {
    // Delay to ensure the HTML has been rendered

    setTimeout(() => {
      const linkElement = this.el.nativeElement.querySelector('#applicationFormLink');
      if (linkElement) {
        this.renderer.listen(linkElement, 'click', () => this.onClickOnemployeeFrom());
      }
    }, 0);
    const editor = this.joditEditor?.editor;
    if (editor) {
      editor.events.on('paste', (event: ClipboardEvent) => {
        event.preventDefault();
        const text = event.clipboardData?.getData('text/plain');
        if (text) {
          const html = text
            .split(/\r?\n/)
            .map(line => `<p>${line.trim()}</p>`)
            .join('');
          editor.selection.insertHTML(html);
        }
      });
    }
  }

  onClickOnemployeeFrom() {
    console.log("Click event triggered");
    this.router.navigate(['elcmfrom', { id: this.loggedInUserCompanyID }]);
  }
  onClickCloseInvitation() {
    this.dialogRef.close();
    this.saveMaildata(true);
  }
  onClickSaveInvitation() {

  }

  openConfirmationDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close();
    });

  }
  openErrorDialog(errorMessage: string) {
    const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: errorMessage,
        btn2: 'OK',
        btn2BgColor: 'red', // Red color for errors
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: true
      }
    });

    errorDialogRef.afterClosed().subscribe(() => {
      console.log('Error dialog closed'); // Optional: Handle post-close actions
    });

    return errorDialogRef;
  }

  saveMaildata(hideDialogue: boolean = false) {
    console.log(this.popupName);

    this.isEditing = !this.isEditing;


    // Reusable function to show error dialogs

    // Optimized validation checks
    if (!this.employeeApplicationEmailBody?.trim()) {
      if (!hideDialogue) this.openErrorDialog('Email body is required');
      return;
    }

    if (!this.invitationEmailSubject?.trim()) {
      if (!hideDialogue) this.openErrorDialog('Email subject is required');
      return;
    }


    // if (this.subjectClick === '') {
    //   // this.openConfirmationDialog("Email Template added Successfully");

    //   return;
    // }
    let strName: any;
    if (this.popupName == 'Create Email Body for Employment application') {
      strName = 'ELCM_EMPLOYEE_APPLICATION';
    } else if (this.popupName == 'Create Email Body for Intimation email') {
      strName = 'Intimation email from candidate';
    } else if (this.popupName == 'Create Email Body for offer letter email') {
      strName = 'Offer letter';
    } else if (this.popupName == 'Create Email Body for Appoinment letter issuance') {
      strName = 'Appointment Latter';
    } else if (this.popupName == 'Confirmation letter mail with no change') {
      strName = 'CONFIRMATION_LETTER_WITHOUT_CHANGES_ELCM';
    } else if (this.popupName == 'confirmation with change') {
      strName = 'CONFIRMATION_LETTER_WITH_CHANGES_ELCM';
    } else if(this.popupName=='Create Email Body Reliving/Experience mail'){
      strName = 'RELIVING_EXPERIENCE';
    }
  else if(this.popupName=='Create Email Body for Termination Mail'){
      strName = 'TERMINATION_LETTER';
    }
    else {
      strName = 'EXTENTION_PROBATION_LETTER_ECLM';
    }



    const isMatchFound = this.allemailtempalteData?.some((item: any) => item.name === strName);
    // console.log(this.allemailtempalteData);
    // console.log(isMatchFound)
    // return;


    let formData = {
      "body": this.employeeApplicationEmailBody,
      "isEnable": true,
      "name": strName,
      "subject": this.emplyeeName + "" + this.invitationEmailSubject,
      "companyId": this.loggedInUserCompanyID,
      "year": this.companyYear
    }
    //   console.log(formData);
    // return false;
    if (this.allemailtempalteData?.length == 0 || !isMatchFound) {
      this.httpService.callPostService(`${this.config.emailtempletFromForEmployee}`, formData).subscribe(
        (data: any) => {
          console.log(data);

          if (data) {
            // Success popup
            if (data && !hideDialogue) {
              this.openConfirmationDialog(data.message);
            }
          }
        },
        (error: any) => {
          const errorMsg = error?.error?.message || 'Something went wrong';
          if (!hideDialogue) {
            this.openErrorDialog(errorMsg);
          }
        }
      );
    } else {
      if (hideDialogue) {
        return;
      }
      this.httpService.callPostService(`${this.config.emailtempletUpdateFormForEmployee}`, formData).subscribe(
        (data: any) => {
          console.log(data);


          if (data) {
            // Success popup
            if (data && !hideDialogue) {
              this.openConfirmationDialog(data.message);
            }
          }
        },
        (error: any) => {
          const errorMsg = error?.error?.message || 'Something went wrong';

          if (!hideDialogue) {
            this.openErrorDialog(errorMsg);
          }
        }
      );
    }
  }


  validateEmailFields() {

    // let contentBodyTemplate = this.decodeHtml(this.letterContentBody);
    // let letterContentBody = this.htmlToPlainText(contentBodyTemplate);

    // let contentsubject = this.decodeHtml(this.letterContentsubject);
    // let subject = this.htmlToPlainText(contentsubject);
    console.log( this.letterContentBody);
    
    const validations = [
      { field: this.letterContentBody.trim(), message: 'Email body is required' },
      { field: this.letterContentsubject.trim(), message: 'Email subject is required' }
    ];

    for (const { field, message } of validations) {
      if (!field) {
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: message,
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showSuccessMessage: false,
          }
        });
        return false;
      }
    }
    return true;
  }

  htmlToPlainText(html: string): string {
    return html
      .replace(/<div>/g, '\n')   // Convert <div> to new line
      .replace(/<\/div>/g, '')   // Remove closing </div>
      .replace(/<br\s*\/?>/g, '\n') // Convert <br> to new line
      .replace(/&nbsp;/g, ' ')  // Convert &nbsp; to space
      .replace(/<\/?[^>]+(>|$)/g, ''); // Remove all remaining HTML tags
  }
  htmlFormatWithWrapper(html: string): string {
    let cleanedHtml = html;

    // Replace non-breaking space entities with normal space
    cleanedHtml = cleanedHtml.replace(/&nbsp;|&#160;/g, ' ');

    // Remove <script> and <style> blocks
    cleanedHtml = cleanedHtml
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<style[\s\S]*?<\/style>/gi, '');

    // Fix void elements to XHTML self-closing style
    cleanedHtml = cleanedHtml

      .replace(/<br(?!\s*\/)>/gi, '<br />')
      .replace(/<hr([^>]*)>/gi, '<hr$1 />')         // FIXED for <hr> with attributes
      .replace(/<img([^>]*)>(?!<\/img>)/gi, '<img$1 />')
      .replace(/<input([^>]*)>(?!<\/input>)/gi, '<input$1 />')
      .replace(/<link([^>]*)>(?!<\/link>)/gi, '<link$1 />');

    // Remove leading/trailing empty or repetitive tags
    cleanedHtml = cleanedHtml
      .replace(/^(?:\s|<br\s*\/?>|<p>\s*<\/p>|<p[^>]*><span[^>]*><br\s*\/?><\/span><\/p>)+/gi, '')
      .replace(/(?:\s|<br\s*\/?>|<p>\s*<\/p>|<p[^>]*><span[^>]*><br\s*\/?><\/span><\/p>)+$/gi, '');

    // Reduce 3+ consecutive <br /> to just two
    cleanedHtml = cleanedHtml.replace(/(<br\s*\/?>\s*){3,}/gi, '<br /><br />');

    // Trim final HTML content
    cleanedHtml = cleanedHtml.trim();

    // Wrap the XHTML-compliant output
    const fullHtml = `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
  <head>
    <style>
      @page {
        size: A4;
        margin-top: 120px;
        margin-bottom: 100px;
        margin-left: 50px;
        margin-right: 40px;
      }
      body {
        margin: 0;
        padding: 0;
        font-family: Calibri, sans-serif;
        font-size: 12pt;
        line-height: 1.5;
      }
    </style>
  </head>
  <body>
    ${cleanedHtml}
  </body>
</html>`;

    return fullHtml;
  }



  isSubmitting = false; // Prevent multiple submissions


  saveMailContentdata() {
    if (this.isSubmitting) return; // Prevent duplicate API calls
    console.log(this.letterContentBody);
    if (!this.validateEmailFields()) return;

    let landingpage = this.employeeApplicationcontentBodyFromFrontEnd == 'Work Anniversary Wishes'
      || this.employeeApplicationcontentBodyFromBackend[0]?.name == 'Work Anniversary Wishes' ||
      this.employeeApplicationcontentBodyFromFrontEnd == 'Birthday Wishes' || this.employeeApplicationcontentBodyFromBackend[0]?.name == 'Birthday Wishes'


    let formData = {
      "id": this.employeeApplicationcontentBodyFromBackend[0]?.id || null,
      "name": this.employeeApplicationcontentBodyFromBackend[0]?.name || this.employeeApplicationcontentBodyFromFrontEnd,
      "title": this.letterContentsubject,
      "content": landingpage ? this.letterContentBody : this.decodeHtmlAndFormat(this.letterContentBody).replace(/&(?!amp;|lt;|gt;|quot;|apos;|#\d+;|#x[0-9a-fA-F]+;)/g, '&amp;'),
      //  "content": this.letterContentBody.replace(/&(?!amp;|lt;|gt;|quot;|apos;|#\d+;|#x[0-9a-fA-F]+;)/g, '&amp;'),
      "companyId": this.loggedInUserCompanyID,
      "year": this.companyYear
    };

    this.isSubmitting = true; // Set flag to prevent multiple calls

    this.httpService.callPostService(`${this.config.addOrUpdateLatter}`, formData).subscribe(
      (data: any) => {
        console.log(data);
        // if (data && this.employeeApplicationcontentBodyFromFrontEnd == 'Birthday Wishes' || this.employeeApplicationcontentBodyFromBackend[0]?.name == 'Birthday Wishes') {
        //   this.httpService.callPutService(`${this.config.addOrUpdateMail}/${this.loggedInUserCompanyID}?fromEmail=${this.letterContentFromBirthday}&type=BIRTHDAY`, {}).subscribe((e: any) => {
        //   })
        // } else if (data && this.employeeApplicationcontentBodyFromFrontEnd == 'Work Anniversary Wishes' || this.employeeApplicationcontentBodyFromBackend[0]?.name == 'Work Anniversary Wishes') {
        //   this.httpService.callPutService(`${this.config.addOrUpdateMail}/${this.loggedInUserCompanyID}?fromEmail=${this.letterContentFromAnniversaries}&type=ANNIVERSARY`, {}).subscribe((e: any) => {
        //   })
        // }

        this.showPopup(data.message, 'success', true);
        this.isSubmitting = false; // Reset flag
      },
      (error: any) => {
        this.showPopup(error.error.message || "An error occurred.", 'danger', false);
        this.isSubmitting = false; // Reset flag
      }
    );
  }
  savetermsAndConditon() {
    if (this.isSubmitting) return; // Prevent duplicate API calls

    if (this.termContent == null || this.termContent == '' || this.termSubject == null || this.termSubject == '') {
      this.showPopup('Elcm latter template title cannot be null', 'danger', false);
      return
    }

    let formData = {
      "id": this.employeeApplicationcontentBodyFromBackend[0]?.id || null,
      "name": this.termName,
      "title": this.termSubject,
      "content": this.decodeHtmlAndFormat(this.termContent),
      "companyId": this.loggedInUserCompanyID,
      "year": this.companyYear
    };

    this.isSubmitting = true; // Set flag to prevent multiple calls

    this.httpService.callPostService(`${this.config.addOrUpdateTermAndCondition}`, formData).subscribe(
      (data: any) => {
        console.log(data);
        this.showPopup(data.message, 'success', true);
        this.isSubmitting = false; // Reset flag
      },
      (error: any) => {
        this.showPopup(error.message || "An error occurred.", 'danger', false);
        this.isSubmitting = false; // Reset flag
      }
    );
  }
  // ✅ Reusable popup function
  showPopup(message: string, color: string, isSuccess: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: color,
        showSuccessIcon: isSuccess,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (isSuccess) this.dialogRef.close(); // Close only on success
    });
  }

}
